var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-switch',_vm._b({class:_vm.classes,model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'md-switch',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }